import { v4 as uuidv4 } from "uuid";
export class UserModel {
    constructor() {
        this.id = uuidv4();
        this.firstName = "";
        this.lastName = "";
        this.emailId = "";
        this.roles = [];
        this.organizationId = "";
    }
}
export default class User extends UserModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
